<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.plan_purchase">
    <div *ngIf="tabs && tabs.length > 0" class="freeze_height">
        <app-tab [tabs]="tabs" [(selectedKey)]="selectedTabKey" [isShowRefresh]="true" (onRefresh)="onInitiate()" />
    </div>
    <div *ngIf="selectedTabKey == '1'" class="banner center" style="max-width: 800px;margin-top: 10px;">
        <div class="row row_header freeze_height">
            <div class="col-6">
                {{localService.languageContent.plan_purchase.plan_type}}
                / {{localService.languageContent.plan_purchase.days}}
            </div>
            <div class="col-2">
                {{localService.languageContent.plan_purchase.total}}
            </div>
            <div class="col-2">
                {{localService.languageContent.plan_purchase.utilized}}
            </div>
            <div class="col-2">
                {{localService.languageContent.plan_purchase.un_utilized}}
            </div>
        </div>
        <div style="margin: 10px;" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngIf="b2bLicenseSummary.length == 0" class="center">
                {{localService.languageContent.common.no_data}}
            </div>
            <div class="row styled_row" *ngFor="let item of b2bLicenseSummary">
                <div class="col-6">
                    {{localService.getText(planTypes, item.v1)}}
                    <span class="en"> / {{item.v3}}</span>
                </div>
                <div class="col-2 right">
                    <span class="en">{{item.v4}}</span>
                </div>
                <div class="col-2 right">
                    <span class="en">{{item.v5}}</span>
                </div>
                <div class="col-2 right">
                    <span class="en">{{item.v6}}</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="selectedTabKey == '2'" class="banner center" style="max-width: 1000px;margin-top: 10px;">
        <div class="row row_header freeze_height">
            <div class="col-3">
                {{localService.languageContent.plan_purchase.issued_on}}
            </div>
            <div class="col-6">
                {{localService.languageContent.plan_purchase.client_name}}
            </div>
            <div class="col-3">
                {{localService.languageContent.plan_purchase.plan_type}}
                / {{localService.languageContent.plan_purchase.days}}
            </div>
        </div>
        <div style="margin: 10px;" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}"
            *ngIf="wrapper && wrapper.items">
            <div class="row styled_row" *ngFor="let item of wrapper.items">
                <div class="col-3">
                    <span class="en" *ngIf="item.v4 && item.v4.length > 5">
                        {{item.v4 | date : 'dd-MMM-yyyy hh:mm a'}}
                    </span>
                </div>
                <div class="col-6">
                    <span>{{item.v6}}</span>
                </div>
                <div class="col-3">
                    {{localService.getText(planTypes, item.v1)}}
                    <span class="en"> / {{item.v3}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="wrapper && wrapper.paging && selectedTabKey == '2'" [paging]="wrapper.paging" [IsSimple]="true"
        [IsShowSimpleCalenderRange]="false" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<span style="display: none;">
    <button class="language_content_loaded" (click)="onLoadTabs()">Loaded</button>
</span>